import PropTypes from "prop-types";
import { Dialog } from "primereact/dialog";

export default function ModulePop({
  headerClassName = "border-bottom-none",
  contentClassName = "px-0",
  className = "",
  onHide = null,
  children = <></>,
  ...popOptions
}) {
  return (
    <Dialog
      header={
        <h2 className="text-center">
          {popOptions.isPop?.[popOptions.popData?.type]?.title(
            popOptions.popData,
          ) ?? ""}
        </h2>
      }
      headerClassName={headerClassName}
      contentClassName={contentClassName}
      visible={popOptions.isPop?.[popOptions.popData?.type]?.isOpen}
      className={className}
      onHide={() =>
        onHide
          ? onHide()
          : popOptions.closePop({ type: popOptions.popData?.type })
      }
      focusOnShow={false}
    >
      {children}
    </Dialog>
  );
}

ModulePop.propTypes = {
  headerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  className: PropTypes.string,
  onHide: PropTypes.func,
  children: PropTypes.node,
  isPop: PropTypes.object,
  popData: PropTypes.shape({
    type: PropTypes.string,
  }),
  closePop: PropTypes.func,
};
